import { useState } from "react";
import axios from "axios";

export const ExcelUpload = ({ title, uploadUrl }) => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleSubmit = async () => {
    if (!file || loading) return;

    const formData = new FormData();
    formData.append("file", file);

    try {
      setLoading(true);
      setMessage("");

      const res = await axios.post(uploadUrl, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      setMessage(res.data?.status || "Submitted successfully");
      setFile(null);
    } catch (err) {
      setMessage(
        err.response?.data?.error ||
        err.response?.data?.message ||
        "Submission failed"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 bg-white rounded-xl shadow-md">
      <h2 className="mb-4 text-xl font-semibold">{title}</h2>

      <input
        type="file"
        accept=".xlsx,.xls"
        onChange={(e) => {
          setFile(e.target.files[0]);
          setMessage("");
        }}
        className="block w-full mb-4"
      />

      <button
        onClick={handleSubmit}
        disabled={!file || loading}
        className="px-6 py-2 text-white bg-blue-600 rounded hover:bg-blue-700 disabled:opacity-50"
      >
        {loading ? "Submitting..." : "Submit"}
      </button>

      {message && (
        <p className="mt-4 text-sm text-gray-700">{message}</p>
      )}
    </div>
  );
};
